module.exports = __webpack_public_path__ + "media/images/image-placeholder-a07a237e34ad7c14581e6bd1af393d19.png";